module.exports = require('../lib/createImmutableMixin')();



/*****************
 ** WEBPACK FOOTER
 ** ./~/fluxible-immutable-utils/mixins/ImmutableMixin.js
 ** module id = 993
 ** module chunks = 0
 **/